import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import moment from 'moment';
import { get } from 'lodash';

import OnMountHomeScroll from 'hoc/OnMountHomeScroll';
import { Footer } from '@goodwaygroup/ui-ux';


const Wrapper = styled.div``;

const Header = styled.header``;

const Title = styled.div``;

const Content = styled.div`
    margin: 30px 25px;
`;

const OuterContentWrapper = styled.div`
    float: right;
    min-height: calc(100vh - 100px);
    width: 100%;
    position: relative;

    @media print {
        float: inherit;
        width: 100%;
    }
`;

const ContentNoSidebarTemplate = ({
    header,
    title,
    children,
    ...props
}) =>
    <Wrapper {...props}>
        <Header>{header}</Header>
        <OuterContentWrapper>
            <Title>{title}</Title>
            <Content>
                {children}
            </Content>
            {get(props.theme, 'whitelabel.showGGBranding', true) &&
                <Footer year={moment().year()} theme={props.theme} />}
        </OuterContentWrapper>
    </Wrapper>;

ContentNoSidebarTemplate.propTypes = {
    header: PropTypes.node.isRequired,
    footer: PropTypes.node,
    title: PropTypes.node,
    children: PropTypes.any.isRequired,
};

export default OnMountHomeScroll()(withTheme(ContentNoSidebarTemplate));



// WEBPACK FOOTER //
// ./src/components/templates/ContentNoSidebar.js